import React from 'react';
export function Footer() {
  return <>
      {/* Final CTA Section */}
      <section className="w-full bg-primary py-20 px-4 text-center" data-id="element-81">
        <div className="max-w-3xl mx-auto" data-id="element-82">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-white mb-8" data-id="element-83">
            Ready to reclaim your time?
          </h2>
          <a href="#pricing" className="inline-block bg-secondary text-white font-bold text-lg sm:text-xl px-10 py-4 rounded-full hover:bg-opacity-90 transition-colors shadow-lg" data-id="element-84">
            GET THE 6-IN-1 BUNDLE NOW
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full bg-[#1A1A1A] py-12 px-4" data-id="element-85">
        <div className="max-w-4xl mx-auto text-center" data-id="element-86">
          <div className="text-white text-2xl font-serif font-black tracking-widest mb-6 flex items-center justify-center gap-2" data-id="element-87">
            <span data-id="element-88">🧘‍♀️</span> YOGA READY
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 text-sm text-white/70 mb-8" data-id="element-89">
            <a href="#" className="hover:text-white transition-colors" data-id="element-90">
              Terms & Conditions
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-91">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-92">
              Contact
            </a>
          </div>

          <p className="text-white/40 text-xs" data-id="element-93">
            © 2026 YOGA READY — All Rights Reserved.
          </p>
        </div>
      </footer>
    </>;
}